import { createContext, useContext, useState, useEffect } from 'react';
import API from './axiosConfig';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const fetchUser = async () => {
    try {
        const token = localStorage.getItem('access_token');
    //   const res = await axios.get('http://localhost:5000/api/me', 
      
      const res = await API.get('/me',{
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setUser(res.data);
    } catch {
      setUser(null);
    }
  };

  useEffect(() => { fetchUser(); }, []);

  return (
    <AuthContext.Provider value={{ user, fetchUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
